<template>
  <div>
    <div class="primary">
      <v-container class="py-0">
        <v-sheet
          height="50px"
          color="transparent"
          class="d-flex align-center justify-space-between"
        >
          <span class="white--text text-capitalize text-body-2">
            Sinop: {{ time }}
          </span>
          <div class="d-flex header-desktop-social">
            <Tooltip
              v-for="({ title, link, icon }, i) in social"
              :key="i"
              :tip="title"
              bottom
            >
              <v-btn
                :href="link"
                target="_blank"
                color="white"
                outlined
                icon
                height="26px"
                width="26px"
              >
                <v-icon size="12">{{ icon }}</v-icon>
              </v-btn>
            </Tooltip>
          </div>
        </v-sheet>
      </v-container>
    </div>
    <v-container class="mx-auto py-0 my-7">
      <div class="d-flex justify-space-between align-center">
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="header-logo"
          />
        </router-link>
        <div>
          <v-btn
            v-for="({ text, to }, i) in menu"
            :key="i"
            :to="to"
            class="text-body-2 text-none header-desktop-nav-btn"
            active-class="primary--text"
            tile
            text
          >
            {{ text }}
          </v-btn>
        </div>
        <Search />
      </div>
    </v-container>
    <v-container class="py-0">
      <v-divider class="header-desktop-divider"></v-divider>
      <v-sheet class="d-flex justify-center" height="42px">
        <v-slide-group :show-arrows="md" center-active>
          <v-slide-item v-for="({ text, to }, i) in categories" :key="i">
            <v-btn
              :to="to"
              class="
                header-desktop-ctg-btn
                text-uppercase text-body-2
                font-weight-medium
              "
              active-class="primary--text"
              height="42px"
              tile
              depressed
              text
            >
              {{ text }}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
      <v-divider class="header-desktop-divider"></v-divider>
    </v-container>
  </div>
</template>

<script>
import Tooltip from "../../tools/Tooltip.vue";
import Search from "@/components/widgets/Search.vue";
import { getSocial } from "@/config.js";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    time: "",
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  mounted() {
    const dateTimeFormat = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      weekday: "long",
    });

    this.time = dateTimeFormat.format(new Date());
  },
  components: {
    Tooltip,
    Search,
  },
};
</script>

<style>
.header-logo {
  max-width: 196px;
}
.header-desktop-divider {
  border-color: #dceaf5 !important;
  border-width: 2px 0px 0px 0px !important;
}

.header-desktop-nav-btn::before {
  color: transparent !important;
}
.header-desktop-nav-btn::after {
  content: "";
  height: 4px;
  width: 0px;
  position: absolute;
  border-radius: 4px;
  bottom: 2px;
  background: var(--v-primary-base);
  transition: 0.3s;
}
.header-desktop-nav-btn {
  margin-top: 0;
  transition: all 0.1s linear;
}
.header-desktop-nav-btn.v-btn--active {
  margin-top: -4px;
}
.header-desktop-nav-btn.v-btn--active::after {
  width: 62px;
}
.header-desktop-ctg-btn::before {
  color: transparent !important;
}
.header-desktop-social {
  gap: 16px;
}
</style>
